import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilter2"><Path d="M2.5 4.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.50195 19.5H15.502" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 12H18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFilter2;
